// COMPOSITE PRODUCTS

(function ($, window, document) {
	// Process these functions only on the .single-product template
	if (!$(document.body).is('.single-product')) {
		return;
	}

	var $product = $('#content').children('.product:first');
	var updateTimeout = null;

	// Gets the base product value: price * qty
	function getProductSubtotal() {
		var cost = 0,
			qty  = 0;

		if ($product.is('.product-type-composite')) {
			cost = parseFloat($('.composite_wrap .composite_price span.amount').last().text().replace("$", ""));
			qty  = parseInt($('.composite_button .quantity input.qty').val(), 10);
		} else {
			cost = parseFloat($('.product-simple-price span.amount').last().text().replace("$", ""));
			qty  = parseInt($('form.cart .quantity input.qty').val(), 10);
		}

		return cost * qty;
	}

	// Updates the total value of the product+addons. Also hides Package Total when the total price is hidden
	function doUpdateTotals() {
		// Get composite product price.
		var total = getProductSubtotal();

		// For each add-on....
		$('.ws_add_ons_wrap .composite_form .amount:visible').each(function () {
			// Check the add-on price.
			var addon_price = parseFloat($(this).text().replace("$", ""));

			// If there is a price than add those add-on prices together
			if (!isNaN(addon_price)) {
				total += addon_price;
			}
		});

		/* Begin July 2019 fix for non-totaling price when addons selected*/
		$('.composite_wrap .composite_price .woocommerce-Price-amount').hide();
		$('.composite_wrap .composite_price .price').append('<span class="woocommerce-Price-amount amount"><div class="ws-composite-total"></div></span>');
		/* End fix */

		// Output the grand total.
		$('.ws-composite-total').text('$' + total.toFixed(2));

		// Hide the grand total if the total is hidden.
		if ($('.composite_price').is(":hidden")) {
			$('.ws-composite-total-wrap').hide();
		} else {
			$('.ws-composite-total-wrap').show();
		}

		updateTimeout = null;
	}

	// Throttled updates so the document is only updated once per 20ms
	$(document.body).on('wdst:addons_total', function () {
		if (updateTimeout) {
			clearTimeout(updateTimeout);
		}

		updateTimeout = setTimeout(doUpdateTotals, 20);
	});

	function removeProductFromCart(product_id, variation_id) {
		return $.post("/wp-admin/admin-ajax.php", {
			action: "product_remove",
			product_id: product_id,
			variation_id: variation_id
		}, 'json');
	}

	// Functions fire after the composite product has completely loaded.
	$('.composite_data').on('wc-composite-initializing', function (event, composite) {

		composite.actions.add_action('composite_initialized', function () {
			// If radio button (product type option) is set to the default, then add an (As Shown) label below that radio select.
			$(".component_option_radio_buttons .component_option_radio_button.selected").parent()
				.append('<div class="ws-as-shown">(As Shown)</div>');
		}, 50);



		// If there is a composite quantity (i.e. 'Sold Individually' is set to No) then... (Should always be set to no as this option is hidden in woo-admin.js)
		if ($('.composite_button .quantity input.qty').length) {
			// Prepend "Package Total: to the output price"
			$('.woocommerce table.shop_table .cart_item.component_container_table_item td.product-subtotal .woocommerce-Price-amount')
				.prepend('Total: ');

			// Prepend the add-ons area to the composite-wrap to position it below the composite options and above the composite price.
			$('.ws_add_ons_wrap').prependTo('.composite_data .composite_wrap').show();
		}

		// Set the component quantity to zero when the composite details window is closed.
		$('.component_option_thumbnail_tap').on('click', function () {
			$(this).closest('.options-style-thumbnails')
				.find('.quantity input.qty').val('0').trigger("change").end()
				.find('.component_content .summary_content .composited_product_details_wrapper').toggle();
		});

		// Append the 2nd checkout button "Add and continue shopping" to the main checkout button.
		$('.ws-continue-shopping-button').appendTo('.composite_data .composite_wrap .composite_button').show();
	});

	$(function ($) {
		// Prepend the add-ons area to the composite-wrap to position it below the composite options and above the composite price.
		$('.ws_add_ons_wrap').prependTo('.ws-cart-group-wrap').show();

		if ($product.is('.product-type-variable')) {
			$('.summary > form.cart .single_variation_wrap')
				.prepend('<div class="ws-composite-total-wrap"><div class="ws-title">Total:</div><div class="ws-composite-total">$0.00</div></div>');
		} else if ($product.is('.product-type-simple')) {
			// Add a Grand Total to the end of the composite form.
			$('.ws-total-price-wrap .price')
				.append('<div class="ws-composite-total-wrap"><div class="ws-title">Total:</div><div class="ws-composite-total">$0.00</div></div>');
		}

		// Add Price to the top of the single product page.
		$(".product-type-simple, .product-type-variable")
			.find('.ws-total-price-wrap .price .woocommerce-Price-amount:first')
			.clone().insertBefore(".ws-cart-group-wrap")
			.wrap("<div class='product-simple-price'>Product Price: </div>");

		$(document.body).on('change', '.summary > .cart .variations select', function () {
			var cost = $('.summary > .cart .single_variation .amount').html();

			if (cost && cost !== '') {
				$('.product-simple-price .amount').html(cost);
				$(document.body).triggerHandler('wdst:addons_total');
			}
		});

		$('.ws-addons-composite_form-wrap .composite_form')
			// Store the product IDs on the .composite_form we use as a parent
			.each(function () {
				var self = $(this);

				self.data('product_id', self.find('[name=product_id]:first').val());
			})
			// When the add-on's select changes...
			.on('change', 'select', function () {
				var self = $(this);
				var form = self.parents('.composite_form:first');
				var promise;

				// When changed, either we're removing the product completely or upgrading it.
				if (form.data('variation_id')) {
					promise = removeProductFromCart(form.data('product_id'), form.data('variation_id'));
				} else {
					promise = $.Deferred().resolve();
				}

				// If changed to the default select option then...
				if (this.value === '') {
					// Change the price to 0 to correctly update the grand total and hide the label.
					form.find('.amount').text('0.00').hide();
				} else {
					// Show the price of the variation
					form.find('.amount').show();
					self.addClass('disabled');
					form.addClass('loading');
					form.removeClass('added');

					promise.done(function () {
						// And trigger it's add to cart button.
						$.post(window.location.href, form.find('form:first').serialize())
							.always(function () {
								form.removeClass('loading');
								form.addClass('added');
								self.removeClass('disabled');
							});
					});
				}

				// Update the chosen variation ID after applying changes.
				form.data('variation_id', form.find('[name=variation_id]:first').val());

				$(document.body).triggerHandler('wdst:addons_total');
			});

		$(document.body).triggerHandler('wdst:addons_total');

		// If an add-on is still in the process of being added to cart then this button should not be clickable. (Relies on jquery.initalize.js)
		$(".loading").initialize(function () {
			$('form.cart .single_add_to_cart_button').addClass('disabled');
		});

		// If an add-on is done being added to cart then remove the disabled state. (Relies on jquery.initalize.js)
		$(".added").initialize(function () {
			$('form.cart .single_add_to_cart_button').removeClass('disabled');
		});

		// When a the composite add to cart button is clicked, ensure it really is disabled if an add-on is still loading.
		$('form.cart .single_add_to_cart_button').click(function (e) {
			if ($('.composite_form.loading').length > 0) {
				e.preventDefault();
				return false;
			}
		});
	});

})(jQuery, window, document);

(function($) {

	/* WooCommerce - Checkout
	 ======================================================================== */

	var $body = $(document.body),
		$form = $('form.woocommerce-checkout'),
		shipping = {
			method: '',
			toOther: $('#ship-to-different-address-checkbox').is(':checked')
		},
		billing = {
			country: $('#billing_country').val()
		}

	$('#billing_country').on("change", function () {
		billing.country = $(this).val();
	});

	$body.on('change', '#shipping_method :radio', function () {
		var method = this.value;

		// WooCommerce uses "local_pickup:6" or "flat_rate:6", but we want the first part
		if (method && method.indexOf(':') > -1) {
			method = method.split(':', 2)[0];
		}

		shipping.method = method;
	});

	$body.on('change', '#ship-to-different-address-checkbox', function () {
		shipping.toOther = !!this.checked;
	});

	// When checkout initializes we'll know what our default shipping method is.
	$body.on('init_checkout', function () {
		$('#shipping_method').find(':radio:checked').trigger('change');
	});


	function if_ship_to_other () {
		// If delivery + ship to other
		return shipping.method === 'flat_rate' && shipping.toOther;
	}

	function if_bill_to_usa() {
		return billing.country === 'US';
	}

	if ($form.length) {
		var $validator = $form.validate({
			focusInvalid: false, // isn't working anyway
			ignore: ":hidden",
			rules: {
				e_deliverydate: "required",

				time_slot: {
					selectcheck: true
				},
				recipient_name: "required",
				billing_first_name: "required",
				billing_last_name: "required",
				billing_email: {
					required: true,
					email: true
				},
				billing_phone: {
					required: true,
					phoneUS: true
				},
				billing_address_1: "required",
				billing_city: {
				},
				billing_state: {
				},
				billing_postcode: {
					//minlength: 5,
					//maxlength: 5,
					digits: {
						depends: if_bill_to_usa
					}
				},
				// billing_country: {
				// },
				shipping_first_name: {
					required: if_ship_to_other
				},
				shipping_last_name: {
					required: false
				},
				shipping_phone: {
					required: if_ship_to_other,
					phoneUS: true
				},
				recipient_phone_num: {
					required: if_ship_to_other,
					phoneUS: true
				},
				shipping_address_1: {
					required: if_ship_to_other
				},
				shipping_city: {
					required: if_ship_to_other
				},
				shipping_state: {
					required: if_ship_to_other
				},
				shipping_postcode: {
					required: if_ship_to_other,
					minlength: 5,
					maxlength: 5,
					digits: true
				},
				banner_message: {
					maxlength: 25,
					required: function () {
						return $('.woocommerce-info[data-require=banner_message]').length > 0;
					}
				},
				greeting_card_message: {
					maxlength: 200,
					required: function () {
						return $('.woocommerce-info[data-require=greeting_card_message]').length > 0;
					}
				},
				order_comments: {
					maxlength: 200
				}
			},
			messages: {
				billing_state: "This field is required.",
				shipping_state: "This field is required."
			},
			invalidHandler: function () {
				// Get the top position of all error label elements (based on the .form-row parent)
				var offsets = $form.find(':input ~ label.error:visible').map(function () {
					return $(this).parents('.form-row:first').offset().top;
				}).get();

				// Scroll to the first form element with an error, or the form top
				var offsetTop = offsets.length
					? Math.min.apply(Math, offsets)
					: $form.offset().top;

				// Compensate for the sticky header(s)
				$(window).scrollTop(offsetTop - 80);
			},
			showErrors: function () {
				this.defaultShowErrors();
				$body.triggerHandler('wdst:validated');
			},
			submitHandler: function() {
				//formatMessages();
			}
		});

		var continue_clicked = false;

		$(document).on('click', '#do-validate-fields', function (e) {
			e.preventDefault();

			// Trigger form validation...
			if ($form.valid()) {
				// If it's valid, note the click for form-state changes
				continue_clicked = true;
			}

			// And trigger our visibility event
			$body.triggerHandler('wdst:validated');
		});

		var validationVisibilityTimeout = null,
			validationVisibilityHandler = function () {
				var $continue = $('#do-validate-fields').parent();
				var $payment = $('#payment');
				var valid = $validator.checkForm();

				if (!continue_clicked || !valid) {
					$continue.show();
					$payment.hide();
				} else if (valid) {
					$continue.hide();
					$payment.show();
				}

				validationVisibilityTimeout = null;
			};


		$(document).ajaxComplete(function (e, xhr, opt) {



			checkAmount();
			handleShipping();


				$body.triggerHandler('wdst:validated');

				if (shipping.method === 'flat_rate') {
					//$("h3:contains('In-Store Pickup Date')").html('Delivery Date & Time');
					//$("label:contains('In-Store Pickup Date')").html('Delivery Date');
					//$("label:contains('In-Store Pickup Time')").html('Delivery Time');

					setTimeout(function () {
						var options = $('#time_slot').find('option');

						if (options.length === 1) {
							options.eq(0).text('Delivery by 7pm');
						} else {
							var times = options.not('[value="select"]');

							times.filter('[value*="01:00 PM"]').text('Before 1:00 PM ($5.99 extra)');
							times.not('[value*="01:00 PM"]').text('Standard Delivery (no time guarantee)');
						}
					}, 100);
				} else {
					// Fix bug where shipping switches back to delivery if pickup is selected and delivery time changed
					$('#shipping_method_0_local_pickup6').prop('checked', true);
					//$("h3:contains('Delivery Date')").html('In-Store Pickup Date & Time');
					//$("label:contains('Delivery Date')").html('In-Store Pickup Date');
					//$("label:contains('Delivery Time')").html('In-Store Pickup Time');
				}

				$("#billing_city_field").removeClass('woocommerce-invalid-required-field');
				$("#billing_city_field").removeClass('woocommerce-invalid');
				$("#billing_city_field").removeClass('validate-required');
				$("#billing_city_field > label > abbr").remove();

				$("#billing_state_field").removeClass('woocommerce-invalid-required-field');
				$("#billing_state_field").removeClass('woocommerce-invalid');
				$("#billing_state_field").removeClass('validate-required');
				$("#billing_state_field > label > abbr").remove();

				$("#billing_postcode_field").removeClass('woocommerce-invalid-required-field');
				$("#billing_postcode_field").removeClass('woocommerce-invalid');
				$("#billing_postcode_field").removeClass('validate-required');
				$("#billing_postcode_field > label > abbr").remove();

				$("#billing_country_field").removeClass('woocommerce-invalid-required-field');
				$("#billing_country_field").removeClass('woocommerce-invalid');
				$("#billing_country_field").removeClass('validate-required');
				$("#billing_country_field > label > abbr").remove();

		});

		// Throttle the visibility handler so that it doesn't get spammed and slow the browser.
		$body.on('wdst:validated init_checkout update_checkout updated_checkout', function () {
			if (validationVisibilityTimeout) {
				clearTimeout(validationVisibilityTimeout);
			}

			// Fix disappearing required astericks for time_slot field
			$('#time_slot_field label').not(':has(.required)').append(' <abbr class="required" title="required" aria-required="true">*</abbr>');

			checkAmount();


			validationVisibilityTimeout = setTimeout(validationVisibilityHandler, 50);
		});

		$body.on('init_checkout updated_checkout', function () {

			// Make sure street address label changes to address
			$('.address-field').find('label[for=billing_address_1]').html('Address <abbr class="required" title="required" aria-required="true">*</abbr>');


		});
	}

	$(document).ready(function () {

		/* WooCommerce Product Archive Page
		 ========================================================================== */

		// Hide Reset Buttons if associated filter is not shown.
		if ($(".ws_color_picker_widget").length) {
			$("#berocket_aapf_widget-6").show();
		} else {
			$("#berocket_aapf_widget-6").hide();
		}

		if ($(".ws_flower_filter_widget").length) {
			$("#berocket_aapf_widget-5").show();
		} else {
			$("#berocket_aapf_widget-5").hide();
			$(".widget_product_categories").css("border", "none");
		}

		/* WooCommerce - My Account (Header)
		 ========================================================================== */

		// Add Username and Password placeholders
		$('#user_login').attr('placeholder', 'Username');
		$('#user_pass').attr('placeholder', 'Password');

		/* WooCommerce - Single Product Page
			========================================================================== */

		// Prevent the lightbox from opening on featured image.
		$('#ws-gallery .woocommerce-main-image').click(function (event) {
			event.preventDefault();
		});

		// Prevent the lightbox from opening on thumbnails.
		$('#ws-gallery .thumbnails a').click(function (event) {
			event.preventDefault();
		});

		// Switch images/thumbnails in and out, prevent double-clicking while animating.
		var wsImageActive = false;
		$('#ws-gallery .thumbnails img').click(function () {
			if (wsImageActive) {
				return;
			}
			wsImageActive = true;
			var thmb = this;
			var src = this.src;
			var parent = $(this).parent();
			var parent_href = $(this).parent().attr('href');
			$(this).removeAttr('srcset').removeAttr('sizes').removeAttr('alt').removeAttr('title')
				.removeAttr('caption url');
			$('#ws-gallery .woocommerce-main-image img').fadeOut(400, function () {
				var mainParent = $(this).parent();
				var mainParent_href = $(this).parent().attr('href');
				thmb.src = $(mainParent).attr('data-ws-image');
				$(mainParent).attr('data-ws-image', src);
				$(mainParent).attr("href", parent_href);
				$(parent).attr("href", mainParent_href);
				$(this).removeAttr('srcset').removeAttr('sizes').removeAttr('alt').removeAttr('title')
					.removeAttr('caption url');
				$(this).fadeIn(400, function () {
					wsImageActive = false;
				})[0].src = parent_href;
				$('.zoomContainer').remove();
				setTimeout(function () {
					$(".woocommerce-main-image img").elevateZoom({responsive: "True"});
				}, 20);
			});
		});

		// Enable zoom for the featured product image. (Relies on elevatezoom-master)
		$(".woocommerce-main-image img").elevateZoom({responsive: "True"});

		// Remove the zoom feature if the window is below 1024px wide.
		$(window).resize(function () {
			if ($(document).width() < 1024) {
				$('.zoomContainer').remove();
			} else {
				$(".woocommerce-main-image img").elevateZoom({responsive: "True"});
			}
		});

		// Change the textarea placeholder of an add-on's textarea [from WooCommerce Product Add-On; currently disabled.]
		$(".woocommerce div.product form.cart .nm-productmeta-box textarea")
			.attr("placeholder", "Type your message here...");

		// When the secondary button is clicked, remove the hidden input set in composite-button.php template override.
		$('.continue-shopping-btn').on('click', function () {
			$('.add-to-cart-btn-detect').remove();
		});

		/*  Collapse shop categories on archive page
		 ========================================================================== */
		// $('.widget_nav_menu .widget-title').append(' <span class="icon icon-minus" style="font-size:13px;"></span>')
		// $('.widget_nav_menu .widget-title').on('click', function() {
		// 	$('.menu-shop-categories-container').toggle();
		// 	$(this).children('.icon').toggleClass('icon-plus').toggleClass('icon-minus');
		// });

		// Change my favorites Stock Status to Status
		$('.product-stock-stauts .nobr').text('Status');

		// Hide Order Delivery Pro field
		$(".woocommerce-account .woocommerce-MyAccount-content strong:contains('Delivery Date:')").parent('p').hide();
		$(".woocommerce-account .woocommerce-MyAccount-content strong:contains('Delivery Time:')").parent('p').hide();

		// Make sure it is still visible on the overview page
		$(".woocommerce-account .woocommerce-MyAccount-content .account-orders-table strong:contains('Delivery Date:')")
			.parent('p').show();
		$(".woocommerce-account .woocommerce-MyAccount-content .account-orders-table strong:contains('Delivery Time:')")
			.parent('p').show();

		$('.ws-order-notes-in-store').hide();

	}); // end.ready

	/*  WooCommerce - Cart
	 ========================================================================== */
	$(document).on('ready updated_cart_totals', function (e) {
		//For each component item in the cart, find it's composite options and append them to the parent product.
		$('.component_table_item').each(function () {
			var self = $(this);
			var component = self.find('.product-name .component');
			var variation = self.find('.product-name .variation');
			var price     = self.find('.product-price .woocommerce-Price-amount');
			var $parent   = self.prev(".component_container_table_item");

			if (component.length) {
				$parent.find('.product-name').append(component);
			}

			if (variation.length) {
				$parent.find('.product-name').append(variation);
			}

			if (price.length) {
				$parent.find('.product-price').prepend(price);
			}
		});
	});

	var shipping_method = null;

	// Hide ws-order-notes if local shipping is selected
	// Change delivery date pro field labels on checkout update
	// Hide the shipping option if local pickup is selected.


	function checkAmount() {
		$(".ws-order-review #shipping_method em").remove();

		subtotalClone = $(".cart-subtotal .woocommerce-Price-amount").clone();
		$("span", subtotalClone).remove();
		subtotalAmount = $(subtotalClone).text();

		pickupShipping = $("#shipping_method label:contains('In-Store Pickup')").attr("for");
		pickupShippingID = "#" + pickupShipping;

		var $shipToOther = $('#ship-to-different-address-checkbox');
		var $notes       = $('.ws-order-notes'),
			$storeNotes  = $('.ws-order-notes-in-store'),
			$shipping    = $('.woocommerce-shipping-fields');

		if (subtotalAmount <= 44.99) {
			shipping.method = "local_pickup";
			$notes.hide();
			$storeNotes.show();
			$shipping.hide();
			$shipToOther.prop('checked', false);
			$(pickupShippingID).prop("checked", true);
			$("#shipping_method li").each(function() {
				if ($(this).find("input" + pickupShippingID).attr("id") != pickupShipping) {
					$(this).hide();
				}
			});

			$(".ws-order-review #shipping_method").append("<em style='font-family:Roboto,sans-serif; font-size:14px;'>Minimum purchase for delivery is $44.99</em>");
		}
	}

	function handleShipping() {
		var $shipToOther = $('#ship-to-different-address-checkbox');

		if (!shipping.toOther && shipping.method === 'flat_rate') {
			$('#order_comments').attr('placeholder', "Please enter your recipient's phone number here.");
		} else {
			$('#order_comments').attr('placeholder', 'Notes about your order, e.g. special notes for delivery.');
		}

		// If the method is unchanged, update nothing else.
		if (shipping_method === shipping.method) {
			return;
		}

		var $notes       = $('.ws-order-notes'),
			$storeNotes  = $('.ws-order-notes-in-store'),
			$shipping    = $('.woocommerce-shipping-fields');

		switch (shipping.method) {
			case 'flat_rate':
				$notes.show();
				$storeNotes.hide();
				$shipping.show();
				$('.shipping_address').show();
				$shipToOther.prop('checked', true);
				break;

			case 'local_pickup':
				$notes.hide();
				$storeNotes.show();
				$shipping.hide();
				$shipToOther.prop('checked', false);
				break;
		}

		shipping_method = shipping.method;
	}

	// Update total if zipcode changes
	$("input").change(function() {
		if ($("#ship-to-different-address-checkbox").is(":checked")) {
			$("#shipping_postcode").blur(function() {
				$(this).trigger("update_checkout");
			});
		} else {
			$("#billing_postcode").blur(function() {
				$(this).trigger("update_checkout");
			});
		}
	});


	function deliveryStatus() {
			if ($("#ship-to-different-address-checkbox").is(":checked")) {
				if (($("#shipping_postcode").val() == "")) {
					$("#shipping_method .woocommerce-Price-amount").html("TBD");
				}
			} else if (($("#billing_postcode").val() == "")) {
				$("#shipping_method .woocommerce-Price-amount").html("TBD");
			}


	}

	setInterval(deliveryStatus, 500);

	// Move recipient name field
	$("#recipient_name_field").clone().appendTo(".ws-ship-to-clarification").addClass("recipient_name_clone").css({"margin-top":"15px"});
	$("#recipient_name_field").not(".recipient_name_clone").remove();

	if ($("#ship-to-different-address-checkbox").prop("checked", true)) {
		$("#recipient_name").hide();
		$("#recipient_name_field").hide();
	}

	$("#ship-to-different-address-checkbox").click(function() {
		if ($(this).is(":checked")) {
			$("#recipient_name_field").hide();
			$("#recipient_name").hide();
		} else {
			$("#recipient_name_field").show();
			$("#recipient_name").show();
		}
	});

	// do stuff after window loaded
	window.addEventListener("load", function () {

		// Remove random validations
		function manualValidate(parent) {
			parent.removeClass( 'woocommerce-invalid woocommerce-invalid-required-field' ).addClass( 'woocommerce-validated' );
		}

    if ($("#billing_state").val() == "") {
			manualValidate( $("#billing_state").parents('.form-row') );
		}

		if ($("#shipping_state").val() == "") {
			manualValidate( $("#shipping_state").parents('.form-row') );
		}

		manualValidate( $("#shipping_postcode").parents('.form-row') );
	});

	// Allow users to hit return on textareas to create multiple lines
	$('#greeting_card_message, #banner_message, #order_comments').keypress(function(event) {
	  if (event.which == 13) {
	    event.preventDefault();
	    this.value = this.value + "\n";
	  }
	});


	Inputmask({"mask": "999-999-9999"}).mask("#billing_phone, #recipient_phone_num");

	$.validator.addMethod('selectcheck', function (value) {
    return (value != 'select');
  }, "Please select a time");







//when the user clicks off of the zip field:
$("#billing_postcode, #shipping_postcode").on("keyup change", function() {

	var zipcode = $(this).val().substring(0, 5);
	var type = "";
	var city = "";
	var state = "";

  var zip = $(this).val();

  if ($(this).is("#billing_postcode")) {
    type = "billing";
  } else {
    type = "shipping";
  }

  function findZip(city, state) {
    $("#" + type + "_city").val(city);
    $("#" + type + "_state").val(state).change();
  }

	if ((zipcode.length) === 5 && ($('#billing_country').val() === 'US')) {

			var url = "https://ZiptasticAPI.com/"+zip;
      $.ajax({
        "url": url,
        "dataType": "json"
      }).done(function(response) {

        findZip(response.city, response.state);

      });

	}
});

// Only show certain composite types in cart
$('.cart .woocommerce-cart-form__cart-item').each(function() {
	if (($(this).find('.component-Type p:not(:contains("Standard"))').length > 0)
		&& ($(this).find('.component-Type p:not(:contains("Deluxe"))').length > 0)
		&& ($(this).find('.component-Type p:not(:contains("Premium"))').length > 0)) {
		$(this).find('.component-Type').hide();
	}
})

}(jQuery));
